import { schema } from 'normalizr';

export const locationOrgSchema = new schema.Entity('locationOrg');
export const locationOrgListSchema = [locationOrgSchema];
